function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function parseListingUnitPrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var match = String(price).match(/[\d.]+/);
  return match ? match[0] : null;
}
function isInsufficientSaito(err) {
  var msg = (err === null || err === void 0 ? void 0 : err.message) || String(err || '');
  return msg.includes('insufficient SAITO balance');
}

/**
 * Yield until after the next paint so preparation UI can render before
 * wallet/WASM work stalls the main thread. Not an artificial delay.
 */
function yieldForPaint() {
  return new Promise(function (resolve) {
    if (typeof requestAnimationFrame !== 'function') {
      setTimeout(resolve, 0);
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
}

/**
 * Purchase transaction orchestration — not a UI component.
 * Shows Purchase Monitor during create/sign/broadcast, then hands off
 * to Transaction Monitor once the signed tx exists.
 */
function startPurchase(_x, _x2, _x3, _x4) {
  return _startPurchase.apply(this, arguments);
}
function _startPurchase() {
  _startPurchase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod, purchaseOverlay, summary) {
    var _mod$main, _mod$main$close, _mod$purchase_lifecyc, _mod$purchase_lifecyc2, _summary$returnPrice, _summary$returnQuanti, _app$wallet$convertSa, _app$wallet$convertSa2, _summary$returnTitle;
    var quantity,
      opts,
      monitor,
      note,
      listingTitle,
      unit_price,
      fee,
      unit_nolan,
      fee_nolan,
      total_nolan,
      resolvedTitle,
      newtx,
      wallet_balance,
      openGetSaito,
      pendingTxSignature,
      _args = arguments,
      _t,
      _t2,
      _t3,
      _t4;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          quantity = _args.length > 4 && _args[4] !== undefined ? _args[4] : 1;
          opts = _args.length > 5 && _args[5] !== undefined ? _args[5] : {};
          monitor = mod.purchase_monitor;
          note = String((opts === null || opts === void 0 ? void 0 : opts.note) || '').trim(); // Immediate UI transition — before any purchase preparation work.
          // Cheap title only; returnTitle()/price hydration happens after paint.
          listingTitle = String((summary === null || summary === void 0 ? void 0 : summary.title) || '').trim() || 'this item';
          (_mod$main = mod.main) === null || _mod$main === void 0 || (_mod$main = _mod$main.listing_detail) === null || _mod$main === void 0 || (_mod$main = _mod$main.overlay) === null || _mod$main === void 0 || (_mod$main$close = _mod$main.close) === null || _mod$main$close === void 0 || _mod$main$close.call(_mod$main);
          (_mod$purchase_lifecyc = mod.purchase_lifecycle) === null || _mod$purchase_lifecyc === void 0 || (_mod$purchase_lifecyc2 = _mod$purchase_lifecyc.hideListing) === null || _mod$purchase_lifecyc2 === void 0 || _mod$purchase_lifecyc2.call(_mod$purchase_lifecyc, summary);
          monitor === null || monitor === void 0 || monitor.show({
            listingTitle: listingTitle
          });
          monitor === null || monitor === void 0 || monitor.setStage('preparing');
          _context.n = 1;
          return yieldForPaint();
        case 1:
          if (summary !== null && summary !== void 0 && summary.nft_id) {
            _context.n = 2;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          salert('This item is not available for purchase.');
          return _context.a(2);
        case 2:
          if (mod.store_public_key) {
            _context.n = 3;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          salert('Store is not connected. Please wait for the Store service to come online.');
          return _context.a(2);
        case 3:
          unit_price = parseListingUnitPrice(((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || summary.price);
          if (!(!unit_price || Number(unit_price) <= 0)) {
            _context.n = 4;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          salert('This item does not have a valid price.');
          return _context.a(2);
        case 4:
          quantity = Math.max(1, Math.min(Number(quantity) || 1, ((_summary$returnQuanti = summary.returnQuantity) === null || _summary$returnQuanti === void 0 ? void 0 : _summary$returnQuanti.call(summary)) || 1));
          fee = String(mod.fee || 0);
          unit_nolan = BigInt((_app$wallet$convertSa = app.wallet.convertSaitoToNolan(unit_price)) !== null && _app$wallet$convertSa !== void 0 ? _app$wallet$convertSa : 0);
          fee_nolan = BigInt((_app$wallet$convertSa2 = app.wallet.convertSaitoToNolan(fee)) !== null && _app$wallet$convertSa2 !== void 0 ? _app$wallet$convertSa2 : 0);
          total_nolan = unit_nolan * BigInt(quantity) + fee_nolan;
          if (!(total_nolan <= 0n)) {
            _context.n = 5;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          salert('Unable to calculate purchase total.');
          return _context.a(2);
        case 5:
          resolvedTitle = ((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || listingTitle;
          newtx = null;
          _context.p = 6;
          monitor === null || monitor === void 0 || monitor.setStage('checking_wallet');
          _context.n = 7;
          return app.wallet.getBalance();
        case 7:
          wallet_balance = _context.v;
          monitor === null || monitor === void 0 || monitor.setStage('creating');
          openGetSaito = false;
          _context.p = 8;
          _context.n = 9;
          return mod.createPurchaseAssetTransaction(summary, {
            price: unit_price,
            fee: fee,
            quantity: quantity,
            note: note
          }, total_nolan);
        case 9:
          newtx = _context.v;
          _context.n = 15;
          break;
        case 10:
          _context.p = 10;
          _t = _context.v;
          if (isInsufficientSaito(_t)) {
            _context.n = 11;
            break;
          }
          console.error('Store: createPurchaseAssetTransaction failed', _t);
          monitor === null || monitor === void 0 || monitor.hide();
          salert((_t === null || _t === void 0 ? void 0 : _t.message) || 'Could not create purchase transaction.');
          return _context.a(2);
        case 11:
          _context.p = 11;
          _context.n = 12;
          return mod.createPurchaseAssetTransaction(summary, {
            price: unit_price,
            fee: fee,
            quantity: quantity,
            note: note,
            unfunded: true
          }, total_nolan);
        case 12:
          newtx = _context.v;
          _context.n = 14;
          break;
        case 13:
          _context.p = 13;
          _t2 = _context.v;
          console.error('Store: unfunded purchase transaction failed', _t2);
          monitor === null || monitor === void 0 || monitor.hide();
          salert((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Could not create purchase transaction.');
          return _context.a(2);
        case 14:
          openGetSaito = true;
        case 15:
          pendingTxSignature = newtx.signature || '';
          if (pendingTxSignature) {
            _context.n = 16;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          salert('Purchase transaction was not signed.');
          return _context.a(2);
        case 16:
          if (!(openGetSaito || wallet_balance < total_nolan)) {
            _context.n = 17;
            break;
          }
          monitor === null || monitor === void 0 || monitor.hide();
          app.connection.emit('saito-purchase-launch', app.wallet.convertNolanToSaito(total_nolan), mod.store_public_key, newtx.serialize_to_web(app), "Purchase ".concat(resolvedTitle || 'Store item'));
          beginLocalPurchaseLifecycle(mod, purchaseOverlay, summary, pendingTxSignature, quantity, resolvedTitle, openGetSaito ? null : newtx);
          if (openGetSaito) {
            // The carrier is not broadcast. BuySaito issues the on-chain payment,
            // so watching this signature would cover Get Saito and never confirm.
            purchaseOverlay.pendingTxSignature = pendingTxSignature;
            purchaseOverlay.listingTitle = resolvedTitle;
            purchaseOverlay.nft_id = String(summary.nft_id || '');
            purchaseOverlay.quantity = quantity;
            if (typeof siteMessage === 'function') {
              siteMessage('Insufficient Saito to Purchase Item');
            }
          }
          return _context.a(2);
        case 17:
          monitor === null || monitor === void 0 || monitor.setStage('sending');
          _context.p = 18;
          _context.n = 19;
          return app.network.propagateTransaction(newtx);
        case 19:
          _context.n = 21;
          break;
        case 20:
          _context.p = 20;
          _t3 = _context.v;
          monitor === null || monitor === void 0 || monitor.hide();
          salert((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'Could not submit purchase transaction.');
          return _context.a(2);
        case 21:
          monitor === null || monitor === void 0 || monitor.hide();
          beginLocalPurchaseLifecycle(mod, purchaseOverlay, summary, pendingTxSignature, quantity, resolvedTitle, newtx);
          _context.n = 23;
          break;
        case 22:
          _context.p = 22;
          _t4 = _context.v;
          monitor === null || monitor === void 0 || monitor.hide();
          console.error('Store: startPurchase failed', _t4);
          salert((_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || 'Could not start purchase.');
        case 23:
          return _context.a(2);
      }
    }, _callee, null, [[18, 20], [11, 13], [8, 10], [6, 22]]);
  }));
  return _startPurchase.apply(this, arguments);
}
function beginLocalPurchaseLifecycle(mod, purchaseOverlay, summary, pendingTxSignature, quantity, listingTitle) {
  var tx = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var lifecycle = mod.purchase_lifecycle;
  if (lifecycle) {
    lifecycle.begin({
      summary: summary,
      purchaseTxSignature: pendingTxSignature,
      quantity: quantity
    });
  } else {
    // Fallback: still hide immediately if lifecycle is unavailable.
    mod.app.connection.emit('store-render-listings');
  }
  if (tx) {
    purchaseOverlay.watchPurchase(tx, listingTitle, {
      nft_id: summary.nft_id,
      quantity: quantity
    });
  }
}
module.exports = {
  startPurchase: startPurchase,
  parseListingUnitPrice: parseListingUnitPrice,
  yieldForPaint: yieldForPaint
};